import { SettingsSidebarProps } from "./types";

export const SettingsSidebar = ({
  sections,
  currentSection,
  onSectionChange
}: Omit<SettingsSidebarProps, 'renderHelpSection'>) => {

  const handleClick = (section: string) => {
    if (onSectionChange) {
      onSectionChange(section);
    }
  }

  return (
    <div className="settings-container-main-nav-wrapper">
      <div className="settings-container-main-nav" role="tablist">
        {sections.map((section) => (
          <div 
            key={section.id} 
            className={`settings-container-main-nav-item ${currentSection === section.id ? 'active' : ''} ${section.id === 'logout' ? 'logout' : ''} ${section.id === 'help' ? 'help' : ''}`} 
            onClick={() => { if (section.onClick) { section.onClick(); } else { handleClick(section.id); } }}
            role="tab"
            aria-selected={currentSection === section.id}
            aria-controls={`panel-${section.id}`}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (section.onClick) { section.onClick(); } else { handleClick(section.id); }
              }
            }}
          >
            <section.icon size={16} className="nav-item-icon" />
            <span>{section.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
